import { fetchWithAuth } from "./fetchWithAuth";
import { withApiKeyHeaders } from "./apiKeyFetch";

const API_BASE = process.env.REACT_APP_API_BASE;

async function parseResponse(response, fallbackMessage) {
  if (!response || !response.ok) {
    let message = fallbackMessage;
    try {
      const payload = await response?.json();
      message = payload?.detail || message;
    } catch {
      // Keep the localized fallback.
    }
    throw new Error(message);
  }
  return response.json();
}

export async function getReviews(limit = 12) {
  const url = `${API_BASE}/reviews?limit=${limit}`;
  const response = await fetch(url, {
    headers: withApiKeyHeaders(url),
  });
  return parseResponse(response, "Неуспешно вчитување на рецензиите.");
}

export async function getMyReview() {
  const response = await fetchWithAuth(`${API_BASE}/reviews/me`, {
    method: "GET",
  });
  return parseResponse(response, "Неуспешно вчитување на вашата рецензија.");
}

export async function saveMyReview({ rating, comment }) {
  const response = await fetchWithAuth(`${API_BASE}/reviews/me`, {
    method: "PUT",
    body: JSON.stringify({ rating, comment }),
  });
  return parseResponse(response, "Неуспешно зачувување на рецензијата.");
}
